<template>
  <ion-page>
    <ion-content class="home-page">
      <div class="main_content_div">
        <div class="user_div">
          <h2></h2>
        </div>
        <div class="top-radius" />
        <div class="content_div">
          <div class="card-heading ion-padding">
          
           <!-- ================= DASHBOARD SOAL ================= -->
        <ion-card class="ion-margin">
          <ion-card-header>
            <ion-card-title>Dashboard Soal</ion-card-title>
          </ion-card-header>
<br>
          <ion-card-content>
            <!-- Tampilkan Total Soal Per Kelas di atas Filter -->
            <div v-if="kelasList.length > 0" class="total-per-kelas ion-margin-bottom">
              <ion-label><strong>Total Soal Per Kelas:</strong></ion-label>
              <div class="kelas-total-grid">
                <div 
                  v-for="kelas in kelasList" 
                  :key="kelas.id"
                  class="kelas-total-item"
                  :class="{ 'active': selectedClass === kelas.id }"
                  @click="selectKelas(kelas.id)"
                >
                  <div class="kelas-name">{{ kelas.name }}</div>
                  <div class="kelas-total">{{ kelasTotal[kelas.id] || 0 }}</div>
                </div>
              </div>
            </div>

            <!-- Filter Kelas -->
            <ion-item>
              <ion-label>Kelas</ion-label>
              <ion-select v-model="selectedClass" placeholder="Pilih Kelas" @ionChange="onClassChange">
                <ion-select-option
                  v-for="k in kelasList"
                  :key="k.id"
                  :value="k.id"
                >
                  {{ k.name }}
                </ion-select-option>
              </ion-select>
            </ion-item>

            <!-- Filter Mata Pelajaran -->
            <ion-item>
              <ion-label>Mata Pelajaran</ion-label>
              <ion-select
                v-model="selectedSubject"
                placeholder="Pilih Mata Pelajaran"
                :disabled="!selectedClass"
                @ionChange="onSubjectChange"
              >
                <ion-select-option
                  v-for="m in mataPelajaranList"
                  :key="m.id"
                  :value="m.id"
                >
                  {{ m.name }}
                </ion-select-option>
              </ion-select>
            </ion-item>

            <!-- Total Soal (berdasarkan filter) -->
            <div class="ion-text-center ion-margin-top">
              <h1>{{ totalSoal }}</h1>
              <p>Total Soal Tersimpan</p>
              <small v-if="selectedClass && selectedSubject">
                Filter: {{ getSelectedClassName() }} - {{ getSelectedSubjectName() }}
              </small>
            </div>
          </ion-card-content>
        </ion-card>
        <!-- ================= END DASHBOARD ================= -->


          </div>
          <br />
          <!-- Menu Utama -->
          <ion-col>Menu</ion-col>
          <ion-grid>
            <ion-row>
              <ion-col size="6">
                <div
                  class="menu-item"
                  :class="{ 'disabled-menu': userStatus === 'non-aktif' }"
                  @click.prevent="toNavigate('tambahsoalkedinasan')"
                  style="
                    background-color: #e91e63;
                    border-radius: 8px;
                    padding: 10px;
                  "
                >
                  <ion-icon
                    :icon="bookmarksOutline"
                    size="large"
                    style="color: #fff"
                  ></ion-icon>
                  <p style="color: #fff">Tambah Soal Kedinasan</p>
                </div>
              </ion-col>

              <ion-col size="6">
                <div
                  class="menu-item"
                  :class="{ 'disabled-menu': userStatus === 'non-aktif' }"
                  @click.prevent="toNavigate('TryOutKedinasan')"
                  style="
                    background-color: #e91e63;
                    border-radius: 8px;
                    padding: 10px;
                  "
                >
                  <ion-icon
                    :icon="bookOutline"
                    size="large"
                    style="color: #fff"
                  ></ion-icon>
                  <p style="color: #fff">Buat Try Out Kedinasan</p>
                </div>
              </ion-col>
              <ion-col size="6">
                <div
                  class="menu-item"
                  :class="{ 'disabled-menu': userStatus === 'non-aktif' }"
                  @click.prevent="toNavigate('tambahsoalsnbt')"
                  style="
                    background-color: #673ab7;
                    border-radius: 8px;
                    padding: 10px;
                  "
                >
                  <ion-icon
                    :icon="bookmarksOutline"
                    size="large"
                    style="color: #fff"
                  ></ion-icon>
                  <p style="color: #fff">Tambah Soal SNBT</p>
                </div>
              </ion-col>

              <ion-col size="6">
                <div
                  class="menu-item"
                  :class="{ 'disabled-menu': userStatus === 'non-aktif' }"
                  @click.prevent="toNavigate('TryOutSnbt')"
                  style="
                    background-color: #673ab7;
                    border-radius: 8px;
                    padding: 10px;
                  "
                >
                  <ion-icon
                    :icon="bookOutline"
                    size="large"
                    style="color: #fff"
                  ></ion-icon>
                  <p style="color: #fff">Buat Try Out SNBT</p>
                </div>
              </ion-col>
              <ion-col size="6">
                <div
                  class="menu-item"
                  :class="{ 'disabled-menu': userStatus === 'non-aktif' }"
                  @click.prevent="toNavigate('tambahsoalCpns')"
                  style="
                    background-color: #03a9f4;
                    border-radius: 8px;
                    padding: 10px;
                  "
                >
                  <ion-icon
                    :icon="bookmarksOutline"
                    size="large"
                    style="color: #fff"
                  ></ion-icon>
                  <p style="color: #fff">Tambah Soal CPNS</p>
                </div>
              </ion-col>
              <ion-col size="6">
                <div
                  class="menu-item"
                  :class="{ 'disabled-menu': userStatus === 'non-aktif' }"
                  @click.prevent="toNavigate('TryOutCpns')"
                  style="
                    background-color: #03a9f4;
                    border-radius: 8px;
                    padding: 10px;
                  "
                >
                  <ion-icon
                    :icon="bookOutline"
                    size="large"
                    style="color: #fff"
                  ></ion-icon>
                  <p style="color: #fff">Buat Try Out CPNS</p>
                </div>
              </ion-col>
              <ion-col size="6">
                <div
                  class="menu-item"
                  :class="{ 'disabled-menu': userStatus === 'non-aktif' }"
                  @click.prevent="toNavigate('tambahsoalGuru')"
                  style="
                    background-color: #03346e;
                    border-radius: 8px;
                    padding: 10px;
                  "
                >
                  <ion-icon
                    :icon="bookOutline"
                    size="large"
                    style="color: #fff"
                  ></ion-icon>
                  <p style="color: #fff">Tambah Soal</p>
                </div>
              </ion-col>
              <ion-col size="6">
                <div
                  class="menu-item"
                  :class="{ 'disabled-menu': userStatus === 'non-aktif' }"
                  @click.prevent="toNavigate('tambahmateriGuru')"
                  style="
                    background-color: #03346e;
                    border-radius: 8px;
                    padding: 10px;
                  "
                >
                  <ion-icon
                    :icon="bookOutline"
                    size="large"
                    style="color: #fff"
                  ></ion-icon>
                  <p style="color: #fff">Tambah Materi</p>
                </div>
              </ion-col>
              <ion-col size="6">
                <div
                  class="menu-item"
                  :class="{ 'disabled-menu': userStatus === 'non-aktif' }"
                  @click.prevent="toNavigate('buatujianGuru')"
                  style="
                    background-color: #03346e;
                    border-radius: 8px;
                    padding: 10px;
                  "
                >
                  <ion-icon
                    :icon="clipboardOutline"
                    size="large"
                    style="color: #fff"
                  ></ion-icon>
                  <p style="color: #fff">Buat Ujian</p>
                </div>
              </ion-col>
              <ion-col size="6">
                <div
                  class="menu-item"
                  :class="{ 'disabled-menu': userStatus === 'non-aktif' }"
                  @click.prevent="toNavigate('lihatHasilUjianGuru')"
                  style="
                    background-color: #03346e;
                    border-radius: 8px;
                    padding: 10px;
                  "
                >
                  <ion-icon
                    :icon="checkboxOutline"
                    size="large"
                    style="color: #fff"
                  ></ion-icon>
                  <p style="color: #fff">Lihat Hasil Ujian</p>
                </div>
              </ion-col>
              <ion-col size="12">
                <div
                  class="menu-item"
                  :class="{ 'disabled-menu': userStatus === 'non-aktif' }"
                  @click.prevent="toNavigate('halamansettingGuru')"
                  style="
                    background-color: #03346e;
                    border-radius: 8px;
                    padding: 10px;
                  "
                >
                  <ion-icon
                    :icon="settingsOutline"
                    size="large"
                    style="color: #fff"
                  ></ion-icon>
                  <p style="color: #fff">Settings</p>
                </div>
              </ion-col>
            </ion-row>
          </ion-grid>
          <!-- Menu Utama -->
          <br />
        </div>
      </div>
      <ion-toast
        :is-open="toast.isOpen"
        :message="toast.message"
        :duration="toast.duration"
        :color="toast.color"
        @did-dismiss="toast.isOpen = false"
      ></ion-toast>
    </ion-content>
  </ion-page>
</template>

<script setup>
import { ref, } from "vue";
import {
  IonPage,
  IonContent,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonItem,
  IonLabel,
  IonSelect,
  IonSelectOption,
  IonGrid,
  IonRow,
  IonCol,
  IonIcon,
  IonToast,
  onIonViewWillEnter
} from "@ionic/vue";

import {
  checkboxOutline,
  bookOutline,
  settingsOutline,
  clipboardOutline,
  bookmarksOutline,
} from "ionicons/icons";
import { useRouter } from "vue-router";
import { getAuth } from "firebase/auth";
import {
  getFirestore,
  doc,
  getDoc,
  collection,
  query,
  getDocs,
  where,
} from "firebase/firestore";
import { firebaseApp } from "../views/firebase.js";

const router = useRouter();

const userName = ref("");
const userStatus = ref("");
const toast = ref({
  isOpen: false,
  message: "",
  duration: 2000,
  color: "success",
});

// Data untuk filter soal
const kelasList = ref([]);
const mataPelajaranList = ref([]);
const kelasTotal = ref({});

const selectedClass = ref("");
const selectedSubject = ref("");
const totalSoal = ref(0);

// Initialize Firebase
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);

// Fetch data ketika view dimuat
onIonViewWillEnter(async () => {
  try {
    const user = auth.currentUser;
    if (user) {
      await fetchUserData(user.uid);
      await fetchKelas();
    } else {
      router.push({ name: "login" });
    }
  } catch (error) {
    console.error("Error in onIonViewWillEnter:", error);
    showToast("Terjadi kesalahan saat memuat data", "danger");
  }
});

const fetchUserData = async (uid) => {
  try {
    const userDoc = await getDoc(doc(db, "users", uid));
    if (userDoc.exists()) {
      const userData = userDoc.data();
      
      // Periksa peran pengguna
      if (userData.role !== "guru") {
        router.push({ name: "login" });
        return;
      }
      
      userName.value = userData.fullName;
      userStatus.value = userData.status;
    } else {
      router.push({ name: "login" });
    }
  } catch (error) {
    console.error("Error fetching user data:", error);
    router.push({ name: "login" });
  }
};

const fetchKelas = async () => {
  try {
    const snapshot = await getDocs(collection(db, "kelas"));
    kelasList.value = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    
    // Hitung total soal per kelas
    await fetchTotalSoalPerKelas();
  } catch (error) {
    console.error("Error fetching kelas:", error);
    showToast("Gagal memuat data kelas", "danger");
  }
};

const fetchTotalSoalPerKelas = async () => {
  try {
    const totals = {};
    
    for (const kelas of kelasList.value) {
      const q = query(
        collection(db, "soal"),
        where("class", "==", kelas.id)
      );
      
      const snapshot = await getDocs(q);
      totals[kelas.id] = snapshot.size;
    }
    
    kelasTotal.value = totals;
  } catch (error) {
    console.error("Error fetching total soal per kelas:", error);
  }
};

const fetchMataPelajaran = async (classId) => {
  try {
    mataPelajaranList.value = [];
    selectedSubject.value = "";
    totalSoal.value = 0;

    const q = query(
      collection(db, "mataPelajaran"),
      where("classId", "==", classId)
    );

    const snapshot = await getDocs(q);
    mataPelajaranList.value = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  } catch (error) {
    console.error("Error fetching mata pelajaran:", error);
    showToast("Gagal memuat mata pelajaran", "danger");
  }
};

const fetchTotalSoal = async () => {
  if (!selectedClass.value || !selectedSubject.value) {
    totalSoal.value = 0;
    return;
  }

  try {
    const q = query(
      collection(db, "soal"),
      where("class", "==", selectedClass.value),
      where("subject", "==", selectedSubject.value)
    );

    const snapshot = await getDocs(q);
    totalSoal.value = snapshot.size;
  } catch (error) {
    console.error("Error fetching total soal:", error);
    totalSoal.value = 0;
  }
};

const onClassChange = (event) => {
  selectedClass.value = event.detail.value;
  if (selectedClass.value) {
    fetchMataPelajaran(selectedClass.value);
  }
};

const onSubjectChange = () => {
  fetchTotalSoal();
};

const getSelectedClassName = () => {
  const kelas = kelasList.value.find(k => k.id === selectedClass.value);
  return kelas ? kelas.name : '';
};

const getSelectedSubjectName = () => {
  const subject = mataPelajaranList.value.find(m => m.id === selectedSubject.value);
  return subject ? subject.name : '';
};

const selectKelas = (kelasId) => {
  selectedClass.value = kelasId;
  fetchMataPelajaran(kelasId);
};

const showToast = (message, color = "success") => {
  toast.value = {
    isOpen: true,
    message,
    duration: 2000,
    color,
  };
};

const toNavigate = (routeName) => {
  if (userStatus.value === "non-aktif") {
    showToast(
      "Akun Anda belum aktif. Silakan hubungi admin untuk mengaktifkan.",
      "danger"
    );
    return;
  }
  
  try {
    router.push({ name: routeName });
  } catch (error) {
    console.error("Navigation error:", error);
    showToast("Gagal navigasi ke halaman", "danger");
  }
};
</script>

<style scoped>
/* Styling untuk grid total per kelas */
.total-per-kelas {
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 8px;
}

.kelas-total-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
  margin-top: 10px;
}

.kelas-total-item {
  background-color: white;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.kelas-total-item.active {
  border-color: #3880ff;
  background-color: #f0f5ff;
}

.kelas-total-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.kelas-name {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 5px;
  color: #333;
}

.kelas-total {
  font-size: 24px;
  font-weight: bold;
  color: #3880ff;
}

/* Styling untuk menu item */
.menu-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 120px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.menu-item:hover {
  transform: scale(1.05);
}

.menu-item.disabled-menu {
  opacity: 0.5;
  cursor: not-allowed;
}

.menu-item.disabled-menu:hover {
  transform: none;
}

.menu-item p {
  margin-top: 8px;
  text-align: center;
  font-size: 14px;
}

/* Responsive untuk mobile */
@media (max-width: 768px) {
  .kelas-total-grid {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 8px;
  }
  
  .kelas-name {
    font-size: 12px;
  }
  
  .kelas-total {
    font-size: 20px;
  }
  
  .menu-item {
    height: 100px;
  }
  
  .menu-item p {
    font-size: 12px;
  }
}
</style>